import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/lab/ahlstrom-interactive': { icon: 'view_in_ar', desc: 'Interactieve storytelling pagina voor Ahlstrom' },
  '/website-preview': { icon: 'language', desc: 'Website preview en feedback tool' },
};

export default function Lab() {
  return (
    <HubPage
      sectionKey="lab"
      subtitle="Experimenten en prototypes"
      headerIcon="science"
      headerAccent={{ color: '#7c3aed', bg: '#ede9fe' }}
      itemMeta={ITEM_META}
    />
  );
}
